module.exports = __webpack_public_path__ + "media/badges/guarantee-badge-3b07100e.svg";